export async function isSyncInProgress() {
    const requestCount = await getRequestCountInSync();
    return requestCount > 0;
}

export function getRequestCountInSync(): Promise<number> {
    return new Promise(resolve => {
        const connection = indexedDB.open('workbox-background-sync');
        const storeName = 'requests';
        connection.onsuccess = () => {
            const db = connection.result;
            if (!hasStore(db, storeName)) {
                return resolve(0);
            }
            const tx = db.transaction([storeName]);
            const store = tx.objectStore(storeName);
            const request = store.getAll();
            request.onsuccess = () => {
                resolve(request.result.length);
            };
        };
    });
}

function hasStore(db: IDBDatabase, storeName: string) {
    return db.objectStoreNames.contains(storeName);
}
